module.exports = __webpack_public_path__ + "img/ITC.84455a43.svg";